import { useCallback, useEffect, useRef } from "react";

type UseDelayedActionArgs = {
  delay: number;
  action: () => void;
};

export const useDelayedAction = ({ action, delay }: UseDelayedActionArgs) => {
  const timeoutRef = useRef<number | null>(null);

  const cancel = useCallback(() => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const run = useCallback(() => {
    cancel();
    timeoutRef.current = window.setTimeout(action, delay);
  }, [action, delay, cancel]);

  useEffect(() => {
    return () => {
      cancel();
    };
  }, [cancel]);

  return {
    run,
    cancel,
  };
};
